import React, { ReactNode } from 'react';
import { Spinner } from '@tcc/crate';
import styles from './cardAndPreview.css';

export interface CardContentProps {
  children?: ReactNode;
  errorMessage?: string;
  isLoading?: boolean;
  spinnerSize?: string;
}

export const CardContent = ({
  children,
  errorMessage,
  isLoading,
  spinnerSize = '30px',
}: CardContentProps) => {
  if (isLoading) {
    return (
      <div className={`${styles.spacedRow} ${styles.centered}`} data-test-id='card-content-loading'>
        <Spinner size={spinnerSize} />
      </div>
    );
  }

  if (errorMessage) {
    return (
      <div className={`${styles.spacedRow} ${styles.centered}`}>
        {errorMessage}
      </div>
    );
  }

  return <div>{children}</div>;
};

export default CardContent;
